import { prop } from 'ramda';
import { createSelector } from 'reselect';

export const selectEventsBySportId = (sportId) =>
  createSelector(prop('events'), (events) =>
    Object.values(events).filter((event) => event.sportId === sportId)
  );
